const digitsRE = /(\d{3})(?=\d)/g;
import DataDict from './dataDict.js'
import EditDict from './editDict.js'
import DataDict_En from './dataDict_en.js'
import EditDict_En from './editDict_en.js'
import i18n from "@/utils/i18n";
//声明变量，用于存储输入框的值。
var temp_th = "";
function amount(th) {
    var regStrs = [
        ['^0(\\d+)$', '$1'], //禁止录入整数部分两位以上，但首位为0
        ['[^\\d\\.]+$', ''], //禁止录入任何非数字和点
        ['\\.(\\d?)\\.+', '.$1'], //禁止录入两个以上的点
        ['^(\\d+\\.\\d{2}).+', '$1'] //禁止录入小数点后两位以上
    ];
    //如果获取不到输入框的值，则会将输入框上次的值赋值给它。以此解决数字输入时，如果输入两个小数点，会被清空内容的情况。
    if (th.value == "") {
        if (temp_th.length == 1) {
            th.value = "";
        } else if (temp_th.length == 2) {
            th.value = "";
        } else {
            th.value = "";
        }
    } else {
        temp_th = th.value;
    }
    for (let i = 0; i < regStrs.length; i++) {
        var reg = new RegExp(regStrs[i][0]);
        th.value = th.value.replace(reg, regStrs[i][1]);
    }
}

//输入金额处理方法（保留小数点后两位，不足两位自动补全）
function formatMoney(th) {
    var v = th.value;
    if (v == '') {
        v = '';
    } else if (v == '0') {
        v = '0.00';
    } else if (v == '0.') {
        v = '0.00';
    } else if (/^0+\d+\.?\d*.*$/.test(v)) {
        v = v.replace(/^0+(\d+\.?\d*).*$/, '$1');
    } else if (/^0\.\d$/.test(v)) {
        v = v + '0';
    } else if (!/^\d+\.\d{2}$/.test(v)) {
        if (/^\d+\.\d{2}.+/.test(v)) {
            v = v.replace(/^(\d+\.\d{2}).*$/, '$1');
        } else if (/^\d+$/.test(v)) {
            v = v + '.00';
        } else if (/^\d+\.$/.test(v)) {
            v = v + '00';
        } else if (/^\d+\.\d$/.test(v)) {
            v = v + '0';
        } else if (/^[^\d]+\d+\.?\d*$/.test(v)) {
            v = v.replace(/^[^\d]+(\d+\.?\d*)$/, '$1');
        } else if (/\d+/.test(v)) {
            v = v.replace(/^[^\d]*(\d+\.?\d*).*$/, '$1');
            // ty = false;
        } else if (/^0+\d+\.?\d*$/.test(v)) {
            v = v.replace(/^0+(\d+\.?\d*)$/, '$1');
            // ty = false;
        } else {
            v = '';
        }
    }
    th.value = v;
    return th.value;
}

// /*cj*/
// //富文本模块最后提交时对img做处理
// function submitUMDataStr(UMDataStr){
//     let reg=new RegExp(commonUrl,'g');
//     UMDataStr=UMDataStr.replace(reg,"");
//     return UMDataStr;
// };
// //富文本数据回显
// function backShowDomAndUM(UMDataStr){
//     let reg=/src="/g;
//     let reg1=/src="https|data:image/g;
//     let reg2=/src="http|data:image/g;
//     if(UMDataStr){
//         if( !((UMDataStr.search(reg1) > -1) || (UMDataStr.search(reg2) > -1)) ){
//             UMDataStr = UMDataStr.replace(reg,'src="'+commonUrl);
//         }
//     }
//     return UMDataStr;
// };

function cloneObj(obj) {
    var result = {};
    for (var key in obj) {
        result[key] = obj[key];
    }
    return result;
}







function intMoney(th, isZero) {
    var reg_whole_number = /\D|^0/g;//正整数 
    if (isZero == '1') {
        th.value = isNaN(parseInt(th.value.replace(/[^0-9-]+/, ''))) ? '0' : parseInt(th.value.replace(/[^0-9-]+/, ''));
    } else {
        th.value = th.value.replace(reg_whole_number, '');
    }
}


function intMoney100(th) {
    // var reg_whole_number = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;//正整数 
    // if (reg_whole_number.test(th.value)) {

    // }
    // //th.value = th.value.replace(reg_whole_number,'');
    if (th.value > 100) {
        th.value = 100;
    }
}
// function intNum(th) {
//     // var reg_whole_number = /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/;//正整数 
//     // if (reg_whole_number.test(th.value)) {
//     // }
//     //th.value = th.value.replace(reg_whole_number,'');
// }

function int100(th) {
    if (th.value) {
        var reg_whole_number = /^0{1}$|^[1-9]{1,2}$|^[1-9]0{1,2}$/;//正整数 
        if (!reg_whole_number.test(th.value)) {
            th.value = "100";
        }
    } else {
        th.value = "";
    }
}

function getUrl() {
    var objs = {};
    var str = window.location.href;
    var num = str.indexOf("?");
    var newStr = str.substr(num + 1);
    var strArr = newStr.split("&");
    var name;
    var val;
    for (var i = 0; i < strArr.length; i++) {
        var arrary = strArr[i].split("=");
        name = arrary[0];
        val = arrary[1];
        objs[name] = val;
    }
    return objs;
}

function getUrlParm(str) {
    var objs = {};
    var name;
    var val;
    var num = str.indexOf("?");
    var newStr = str.substr(num + 1);
    if (str.indexOf("&") > 0) {//说明有多个参数
        var strArr = newStr.split("&");
        for (var i = 0; i < strArr.length; i++) {
            var arrary = strArr[i].split("=");
            name = arrary[0];
            val = arrary[1];
            objs[name] = val;
        }
    } else {//一个参数
        arrary = newStr.split("=");
        name = arrary[0];
        val = arrary[1];
        objs[name] = val;
    }


    return objs;
}

//金额的处理
function currency(value, currency, decimals) {
    value = parseFloat(value)
    if (!isFinite(value) || (!value && value !== 0)) return '￥0.00'
    currency = currency != null ? currency : '￥'
    decimals = decimals != null ? decimals : 2
    var stringified = Math.abs(value).toFixed(decimals)
    var _int = decimals
        ? stringified.slice(0, -1 - decimals)
        : stringified
    var i = _int.length % 3
    var head = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
        : ''
    var _float = decimals
        ? stringified.slice(-1 - decimals)
        : ''
    var sign = value < 0 ? '-' : ''
    return sign + currency + head +
        _int.slice(i).replace(digitsRE, '$1,') +
        _float
}

function format2Money(amount) {     // 金额转换三位加，不足三位不加，小数位数不处理
    // 确保是数字  
    if (typeof amount !== 'number' || isNaN(amount)) {  
        return 'Invalid input';  
    }  
  
    // 分离整数部分和小数部分  
    const integerPart = Math.floor(amount);  
    const decimalPart = amount - integerPart;  
  
    // 格式化整数部分  
    let formattedInteger = integerPart.toString();  
    if (formattedInteger.length >= 4) {  
        // 每三位添加一个逗号  
        formattedInteger = formattedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, ',');  
    }  
  
    // 处理小数部分，不足三位则不添加零  
    let formattedDecimal = decimalPart.toFixed(2); // 获取小数部分，并转换为字符串（保留两位小数）  

    if (decimalPart === 0) {  
        formattedDecimal = ''; // 如果原数是整数，则小数部分为空  
    } else {  
        // 移除前导零  
        formattedDecimal = formattedDecimal.replace(/^0+/, '');  
        // 如果小数部分处理后为空（即原小数部分是.00），则添加.00  
        if (formattedDecimal === '') {  
            formattedDecimal = '.00';  
        } else {  
            // 否则添加小数点  
            formattedDecimal =  formattedDecimal;  
        }  
    }  
  
    // 合并整数部分和小数部分  
    return formattedInteger + formattedDecimal;  
}  
  
//提示信息


// var getBank = {
//     getBankLabel: function (code) {
//         var label;
//         headBankCode.forEach(item => {
//             if(code == item.value) {
//                 label = item.label;
//             }
//         });
//         return label;
//     },
// }

let dataALL= {}
dataALL.zh = Object.assign(DataDict,EditDict) 
dataALL.en = Object.assign(DataDict_En,EditDict_En)
// 获取数据字典类型值
function getDictType(eve) {
    var tt = dataALL[i18n.global.locale.value][eve];
    if (tt) {
        return tt;
    } else {
        return {};
    }
}

//获取数据字典label
function getDictLabel(eve, val) {
    var tt = dataALL[i18n.global.locale.value][eve];
    if (tt) {
        for (var i = 0; i < tt.length; i++) {
            if (tt[i].value == val) {
                return tt[i].label;
            }
        }
    } else {
        return {};
    }
}
// let DataBank = require('./yopBankCode')
// // 获取数据字典类型值
// function getDictType1(eve) {
// 	var tt = DataBank[eve];
// 	if (tt) {
// 		return tt;
// 	} else {
// 		return {};
// 	}
// }
//获取数据字典label
// function getDictLabel1(eve, val) {
// 	var tt = DataBank[eve];
// 	if (tt) {
// 		for (var i = 0; i < tt.length; i++) {
// 			if (tt[i].code == val) {
// 				return tt[i].name;
// 			}
// 		}
// 	} else {
// 		return {};
// 	}
// }

//金额计算--加法
function accAdd(...arg) {
    var sum = 0;
    var m;
    var arr = [];
    arg.forEach((item, index) => {
        try {
            arr[index] = item.toString().split(".")[1].length;
        } catch (e) { arr[index] = 0 }
    })
    m = Math.pow(10, Math.max(...arr));
    arg.map(item => {
        sum += item * m;
    });
    return sum / m;
}

//金额计算--减法
function accSub(num, ...arg) {
    var sum = 0,
        m,
        arr = [],
        sub = 0;
    arg.forEach((item, index) => {
        try {
            arr[index] = item.toString().split(".")[1].length;
        } catch (e) { arr[index] = 0 }
    })
    m = Math.pow(10, Math.max(...arr));
    arg.map(item => {
        sum += item * m;
    });
    sub = num * m - sum
    return sub / m;
}


//秒转时分秒
let formatTime = (s) => {
    var t;
    if (s > -1) {
        var hour = Math.floor(s / 3600);
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;
        if (hour < 10) {
            t = '0' + hour + "时";
        } else {
            t = hour + "时";
        }
        if (min < 10) {
            t += "0";
        }
        t += min + "分";
        if (sec < 10) {
            t += "0";
        }
        t += parseInt(sec) + "秒";
    }
    return t;
}
//毫秒转换为格式化日期
let formatDate = (time, format) => {
    if (time) {
        var t = new Date(time);
        var tf = function (i) {
            return (i < 10 ? '0' : '') + i
        };
        return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
            switch (a) {
                case 'yyyy':
                    return tf(t.getFullYear());
                case 'MM':
                    return tf(t.getMonth() + 1);
                case 'mm':
                    return tf(t.getMinutes());
                case 'dd':
                    return tf(t.getDate());
                case 'HH':
                    return tf(t.getHours());
                case 'ss':
                    return tf(t.getSeconds());
            }
        })
    } else {
        return "";
    }

};

// 补全小时数据
let completeHours = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    // 创建一个包含24小时的完整时间轴映射
    const fullHoursMap = new Map();
    for (let i = 0; i < 24; i++) {
        fullHoursMap.set(i.toString(), { num: 0, dateTime: i.toString() });
    }
    
    // 覆盖已有数据
    dataArray.forEach(item => {
        if (item && item.dateTime) {
            fullHoursMap.set(item.dateTime, item);
        }
    });
    
    // 转换为数组并按小时排序
    const result = [];
    for (let i = 0; i < 24; i++) {
        result.push(fullHoursMap.get(i.toString()));
    }
    
    return result;
};

// 补全日期数据
let completeDates = (dataArray, days) => {
    if (!dataArray || !Array.isArray(dataArray) || !days) return [];
    
    // 创建一个包含指定天数的完整日期轴映射
    const fullDatesMap = new Map();
    const endDate = new Date();
    
    // 检查数据中日期的格式
    let dateFormat = 'yyyy-MM-dd';
    if (dataArray.length > 0 && dataArray[0].dateTime) {
        // 如果日期不包含年份，则使用MM-dd格式
        if (dataArray[0].dateTime.length <= 5) {
            dateFormat = 'MM-dd';
        }
    }
    
    for (let i = days - 1; i >= 0; i--) {
        const date = new Date(endDate);
        date.setDate(endDate.getDate() - i);
        const formattedDate = formatDate(date, dateFormat);
        fullDatesMap.set(formattedDate, { num: 0, dateTime: formattedDate });
    }
    
    // 覆盖已有数据
    dataArray.forEach(item => {
        if (item && item.dateTime) {
            fullDatesMap.set(item.dateTime, item);
        }
    });
    
    // 转换为数组并按日期顺序排序
    const result = [];
    const endDateObj = new Date();
    
    for (let i = days - 1; i >= 0; i--) {
        const date = new Date(endDateObj);
        date.setDate(endDateObj.getDate() - i);
        const formattedDate = formatDate(date, dateFormat);
        result.push(fullDatesMap.get(formattedDate));
    }
    
    return result;
};

// 填充缺失的日期数据
let fillMissingDates = (startDate, endDate, dataArray) => {
    if (!startDate || !endDate || !dataArray || !Array.isArray(dataArray)) return [];
    
    // 将现有数据转换为映射
    const dataMap = new Map();
    dataArray.forEach(item => {
        if (item && item.dateTime) {
            dataMap.set(item.dateTime, item);
        }
    });
    
    // 解析开始和结束日期
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    // 创建完整的日期轴并填充数据
    const result = [];
    const currentDate = new Date(start);
    
    while (currentDate <= end) {
        const formattedDate = formatDate(currentDate, 'yyyy-MM-dd');
        // 如果有数据则使用现有数据，否则创建新数据
        const existingItem = dataMap.get(formattedDate);
        if (existingItem) {
            result.push(existingItem);
        } else {
            result.push({ num: 0, dateTime: formattedDate });
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }
    
    return result;
};

let openWindow = (href, type) => {
    // var newWin = window.open();
    // newWin.location = href

    const a = document.createElement('a');
    a.target = '_blank';
    a.href = href
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

};
const convertToWanFormatted = (num,digit = 2) => {  //转换为万元并且指定几位小数
    // 处理非数字类型（可选）
    if (typeof num !== 'number') {
        num = parseFloat(num) || 0; // 非数字转为0，避免NaN
    }
    // 转换为万元，并固定保留指定位数的小数（自动补零）
    return (num / 10000).toFixed(digit); 
}  
function formatDecimal(num) {
    const number = Number(num);
    if (isNaN(number)) return '0.00';
    
    // 始终保留两位小数
    return number.toFixed(2);
}
export {
    formatMoney,
    format2Money,
    formatDecimal,
    amount,
    // getPageNav,
    cloneObj,
    intMoney,
    intMoney100,
    convertToWanFormatted,
    // intNum,
    int100,
    getUrl,
    getUrlParm,
    //WiseaIMUIFn,
    currency,
    // submitUMDataStr,
    // backShowDomAndUM,
    //confirmFun,
    // getBank,
    //hitTip,
    accAdd,
    accSub,
    getDictType,
    getDictLabel,
    // getDictType1,
    // getDictLabel1,
    formatTime,
    formatDate,
    openWindow,
    completeHours,
    completeDates,
    fillMissingDates
}